export enum AnswerEnum {
  YES = 'yes',
  NO = 'no',
  NOT_APPLICABLE = 'not applicable',
  // tslint:disable-next-line: quotemark
  CANT_ANSWER = "can't answer"
}
